/**
 * SDR EOD Form - Public submission form
 * URL: /sdr-eod
 *
 * Renders questions dynamically from the database config.
 */

import { DynamicEodForm } from "./DynamicEodForm";

export function SdrEodForm() {
  return (
    <DynamicEodForm
      formType="sdr"
      submitUrl="/api/eod/submit/sdr"
      fallbackTitle="SDR EOD Report"
      fallbackSubtitle="Fill out your daily setting report"
    />
  );
}

export default SdrEodForm;
